export const CloudResourceType = Object.freeze({
  FORM_PREVIEWS: 'form_previews',
  GALLERY: 'gallery',
  USER_IMAGES: 'user_images',
  HELP_DESK: 'help_desk',
})

export const getCdnHost = (type) => {
  return (
    {
      [CloudResourceType.GALLERY]: process.env.NEXT_PUBLIC_CDN_HOST_GALLERY || process.env.REACT_APP_CDN_HOST_GALLERY,
      [CloudResourceType.FORM_PREVIEWS]:
        process.env.NEXT_PUBLIC_CDN_HOST_FORM_PREVIEWS || process.env.REACT_APP_CDN_HOST_FORM_PREVIEWS,
      [CloudResourceType.USER_IMAGES]:
        process.env.NEXT_PUBLIC_CDN_HOST_USER_IMAGES || process.env.REACT_APP_CDN_HOST_USER_IMAGES,
      [CloudResourceType.HELP_DESK]:
        process.env.NEXT_PUBLIC_CDN_HOST_HELP_DESK || process.env.REACT_APP_CDN_HOST_HELP_DESK,
    }[type] || ''
  )
}

export const getS3Bucket = (type) => {
  return (
    {
      [CloudResourceType.GALLERY]: process.env.REACT_APP_S3_BUCKET_GALLERY,
      [CloudResourceType.HELP_DESK]: process.env.REACT_APP_S3_BUCKET_HELP_DESK,
    }[type] || ''
  )
}

export const getCdnEnvPrefix = () => {
  return process.env.NEXT_PUBLIC_CDN_ENV_PREFIX || process.env.REACT_APP_CDN_ENV_PREFIX || ''
}
